import { render, staticRenderFns } from "./automaticCryptoDeposit.vue?vue&type=template&id=11549de6&scoped=true"
import script from "./automaticCryptoDeposit.vue?vue&type=script&lang=js"
export * from "./automaticCryptoDeposit.vue?vue&type=script&lang=js"
import style0 from "./automaticCryptoDeposit.vue?vue&type=style&index=0&id=11549de6&prod&lang=scss"
import style1 from "./automaticCryptoDeposit.vue?vue&type=style&index=1&id=11549de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11549de6",
  null
  
)

export default component.exports